











































































































import { Component, Vue } from 'vue-property-decorator'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import DanhGiaNDDTaoBaoCao from './DanhGiaNDDTaoBaoCao.vue'
import DanhGiaNDDDuLieuBaoCao from './DanhGiaNDDDuLieuBaoCao.vue'
import DGNDDBaoCaoGanDay from './DGNDDBaoCaoGanDay.vue'
import { CompanyRepresentativeReport, RecentReport } from '@/utils/Interfaces'
import {
  getCompanyRepresentativeReport,
  postDGNDDReportExcel,
  downloadDGNDDReportExcel,
  getRecentDGNDDReports,
} from '@/utils/ApiServices'
import { handle } from '@/utils/ErrorHandling'
import { AxiosResponse } from 'axios'
import fileDownload from 'js-file-download'

@Component({
  components: {
    BreadCrumbs,
    SectionTitle,
    DanhGiaNDDTaoBaoCao,
    DanhGiaNDDDuLieuBaoCao,
    DGNDDBaoCaoGanDay,
  }
})
export default class DanhGiaNDD extends Vue {
  breadcrumbs = [
    {
      text: 'Trang chủ',
      to: { name: 'Home' },
    },
    {
      text: 'Đánh giá người đại diện',
      to: { name: 'DanhGiaNDD' },
    },
  ]
  companies = []
  searchText = ''
  recentReports = []

  loading = false
  showRecentReports = true
  showReportCreate = true
  showReportData = true

  // ======================================================================

  fetchingReports = true
  companyRepresentativeReports: Array<CompanyRepresentativeReport> = []

  fetchingRecentReports = false
  recentReportExcels: Array<RecentReport> = []

  mounted () {
    this.updateReportData()
    this.updateRecentReports()
  }

  updateReportData () {
    this.fetchingReports = true
    getCompanyRepresentativeReport(this.year)
      .then(response => {
        this.companyRepresentativeReports = response.data
      })
      .catch(handle)
      .finally(() => {
        this.fetchingReports = false
      })
  }

  updateRecentReports () {
    this.fetchingRecentReports = true
    getRecentDGNDDReports()
      .then(response => {
        this.recentReportExcels = response.data
      })
      .catch(handle)
      .finally(() => {
        this.fetchingRecentReports = false
      })
  }

  // ======================================================================

  year = (new Date).getFullYear() - 1  // Lấy 1 năm trước so với năm hiện tại
  reportTypes = ['PLDGNDD']

  downloading = false

  async download () {
    if (this.downloading) return
    this.downloading = true

    const response = await postDGNDDReportExcel(this.year).catch(error => {
      this.downloading = false
      handle(error)
    }) as AxiosResponse
    const id = response.data.id

    downloadDGNDDReportExcel(id)
      .then(response => {
        const filename = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim()
        fileDownload(response.data, filename)
        this.updateRecentReports()
      })
      .catch(handle)
      .finally(() => {
        this.downloading = false
      })
  }
}
